import React from 'react'

export const IconPreApprovedTitle = () => (
  <svg width="45" height="53" viewBox="0 0 45 53" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.95738 39.3217L18.7322 15.3145L28.904 23.3944L7.95738 39.3217Z" fill="#FCCC00" />
    <path d="M4.09678 34.2062L2.36688 8.51756L9.46236 9.02468L4.09678 34.2062Z" fill="#DE0C4B" />
    <path d="M10.5362 45.1543L35.6786 37.3892L36.3297 50.3633L10.5362 45.1543Z" fill="#5CB5FE" />
  </svg>
)
